import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("amden_token");
    if (!token) {
      setUser(null);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("amden_token");
        setUser(null);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("amden_token", data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("amden_token");
    localStorage.removeItem("amden_org");
    setUser(null);
  };

  const isAmden = user && ["amden_super_admin", "amden_consultant"].includes(user.role);
  const isSuper = user && user.role === "amden_super_admin";
  const canEdit = user && user.role !== "read_only";

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, isAmden, isSuper, canEdit, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
